import React, { use, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Autocomplete, TextField, Chip, Box } from "@mui/material";
import BaseUrl from "../Components/BaseUrl";
import Cookies from "js-cookie";
const Onboardingstep6 = () => {
  const navigate = useNavigate();
  const [jobTitleMap, setJobTitleMap] = useState([]);
  const [formData, setFormData] = useState({
    job_titles: [],
    job_locations: [],
  });
  const [error, setError] = useState({
    job_titles: "",
    job_locations: "",
  });
  const [jobTitlesData, setJobTitlesData] = useState([]);

  const getData = async () => {
    const response = await axios.get(BaseUrl + "jobtitles");
    setJobTitlesData(response.data.data);
    console.log(response.data.data,"sdasd");
  };
  useEffect(() => {
    getData();
  }, []);

  const locationsData = [
    "New York",
    "Los Angeles",
    "Chicago",
    "Houston",
    "Miami",
    "San Francisco",
    "Dallas",
    "Boston",
    "Seattle",
    "Denver",
  ];

  const handleJobTitleChange = (event, newValue) => {
    if (newValue.length <= 5) {
      setFormData((prev) => ({
        ...prev,
        job_titles: newValue.map((item) => item.id), 
      }));
    }
    const jobMap = newValue.reduce((acc, item) => {
      acc[item.id] = item.job_title;
      return acc;
    }, {});

    setJobTitleMap(jobMap);
  };

  const handleLocationChange = (event, newValue) => {
    if (newValue.length <= 5) {
      setFormData((prev) => ({
        ...prev,
        job_locations: newValue,
      }));
    }
  };

  const validateForm = () => {
    let isValid = true;
    let errors = {};

    if (formData.job_titles.length === 0) {
      errors.job_titles = "At least one job title is required";
      isValid = false;
    }

    if (formData.job_locations.length === 0) {
      errors.job_locations = "At least one job location is required";
      isValid = false;
    }

    setError(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user_id = Cookies.get('user_id');
    if (validateForm()) {
      window.localStorage.setItem(
        "job_titles",
        JSON.stringify(jobTitleMap)
      );
      window.localStorage.setItem(
        "job_locations",
        JSON.stringify(formData.job_locations)
      );
      const response = await axios.post(BaseUrl + "onboarding/step6",formData,
        {
          headers: {
            "user-id": user_id,
          },
        }
      );
      console.log(formData,"formData");
      
    }
    navigate("/user/onboarding/step7");
  };

  return (
    <div className="flex flex-col items-center mt-16 justify-start min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md text-center mb-4">
        <p className="text-2xl mb-2">What kind of job are you looking for?</p>
        <p className="text-[14px] text-gray-500">
          You can select up to 5 titles and locations
        </p>
      </div>

      <div className="w-full max-w-md">
        <form className="bg-white p-8 rounded-lg shadow-xl">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-1">
              Job Titles <span className="text-red-500">*</span>
            </label>
            <Box sx={{ width: 400 }}>
              <Autocomplete
                multiple
                options={jobTitlesData}
                getOptionLabel={(option) => option.job_title}
                value={jobTitlesData.filter((job) =>
                  formData.job_titles.includes(job.id)
                )}
                onChange={handleJobTitleChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select or type job titles"
                  />
                )}
                renderTags={() => null}
              />
            </Box>
            {/* <div className="flex flex-wrap gap-2 mt-2">
              {formData.job_titles.map((title, index) => (
                <Chip
                  key={index}
                  label={title}
                  onDelete={() =>
                    handleJobTitleChange(
                      null,
                      formData.job_titles.filter((t) => t !== title)
                    )
                  }
                />
              ))}
            </div> */}
            <div className="flex flex-wrap gap-2 mt-2">
              {formData.job_titles.map((id) => {
                const job = jobTitlesData.find((job) => job.id === id);
                return job ? (
                  <Chip
                    key={id}
                    label={job.job_title} // Display job_title
                    onDelete={() =>
                      setFormData((prev) => ({
                        ...prev,
                        job_titles: prev.job_titles.filter(
                          (jobId) => jobId !== id
                        ),
                      }))
                    }
                  />
                ) : null;
              })}
            </div>

            <span className="text-red-500 text-sm">{error.job_titles}</span>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-1">
              Job Locations <span className="text-red-500">*</span>
            </label>
            <Box sx={{ width: 400 }}>
              <Autocomplete
                multiple
                options={locationsData}
                value={formData.job_locations}
                onChange={handleLocationChange}
                // disableCloseOnSelect
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select or type job locations"
                  />
                )}
                renderTags={() => null}
              />
            </Box>
            <div className="flex flex-wrap gap-2 mt-2">
              {formData.job_locations.map((location, index) => (
                <Chip
                  key={index}
                  label={location}
                  onDelete={() =>
                    handleLocationChange(
                      null,
                      formData.job_locations.filter((l) => l !== location)
                    )
                  }
                />
              ))}
            </div>
            <span className="text-red-500 text-sm">{error.job_locations}</span>
          </div>
          <div className="flex items-center">
            <input type="checkbox" className="w-4 h-4" id="terms" />
            <label htmlFor="terms" className="ml-2 text-sm text-gray-600">
              I'm open to remote work
            </label>
          </div>

          <div className="mt-8 flex flex-col items-center">
            <button
              className="bg-[#0A66C2] hover:bg-blue-700 text-white text-lg font-bold py-2 px-4 h-12 rounded-full w-full"
              type="button"
              onClick={handleSubmit}
            >
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Onboardingstep6;
